import gsap from 'gsap';
import normalizeWheel from '../helpers/normalizeScroll';

export const dragByScroll = styles => {
  if (typeof document !== `undefined`) {
    let page = document.getElementById('roomPage');
    let isDown = false;
    let startX;
    let scrollLeft;

    page.addEventListener('mousedown', e => {
      isDown = true;
      page.classList.add(styles.active);
      startX = e.pageX - page.offsetLeft;
      scrollLeft = page.scrollLeft;
    });

    page.addEventListener('mouseleave', () => {
      isDown = false;
      page.classList.remove(styles.active);
    });

    page.addEventListener('mouseup', () => {
      isDown = false;
      page.classList.remove(styles.active);
    });

    page.addEventListener('mousemove', e => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - page.offsetLeft;
      const walk = (x - startX) * 4;
      page.scrollLeft = scrollLeft - walk;

      const iconList = document.getElementById('iconList');
      if (walk > 100) {
        iconList.classList.add(styles.skewLeftVerticalLine);
        iconList.classList.remove(styles.skewRightVerticalLine);
        iconList.classList.remove(styles.resetSkewVerticalLine);
      } else if (walk < -100) {
        iconList.classList.add(styles.skewRightVerticalLine);
        iconList.classList.remove(styles.skewLeftVerticalLine);
        iconList.classList.remove(styles.resetSkewVerticalLine);
      } else {
        iconList.classList.add(styles.resetSkewVerticalLine);
        iconList.classList.remove(styles.skewRightVerticalLine);
        iconList.classList.remove(styles.skewLeftVerticalLine);
      }
    });

    /**
     * Trigger horizontal scroll from mouse
     */
    page.addEventListener('wheel', event => {
      const normalizedWheel = normalizeWheel(event);

      const isTouchPad = event.wheelDeltaY
        ? event.wheelDeltaY === -3 * event.deltaY
        : event.deltaMode === 0;
      const toLeft = event.deltaY < 0 && page.scrollLeft > 0;
      const toRight =
        event.deltaY > 0 &&
        page.scrollLeft < page.scrollWidth - page.clientWidth;

      if (toLeft || toRight) {
        event.preventDefault();
        if (isTouchPad) {
          page.scrollLeft += event.deltaY;
        } else {
          gsap.to(page, {
            scrollTo: { x: `+=${normalizedWheel.pixelY * 4}` },
            ease: 'power1.easeOut',
            duration: 2,
          });
        }
      }
    });

    /**
     * Commented parallax effect on scroll, until we decide if we need it or not
     */
    page.addEventListener('scroll', () => {
      const iconList = document.getElementById('iconList');
      if (page.scrollLeft > 700) {
        iconList.classList.add(styles.skewRightVerticalLine);
        iconList.classList.remove(styles.skewLeftVerticalLine);
        iconList.classList.remove(styles.resetSkewVerticalLine);
      } else {
        iconList.classList.add(styles.resetSkewVerticalLine);
        iconList.classList.remove(styles.skewRightVerticalLine);
        iconList.classList.remove(styles.skewLeftVerticalLine);
      }
    });
  }
};

export const checkIfScroll = (index, isMobile) => {
  if (typeof window !== `undefined` && typeof document !== `undefined`) {
    if (window.IntersectionObserver) {
      const icon = document.getElementById(`icon${index}`);
      const iconFixed = document.getElementById(`iconFixed${index}`);
      const mobileIcon = document.getElementById(`mobileIcon${index}`);
      const observer = new IntersectionObserver(
        entries => {
          if (!entries[0].isIntersecting) {
            iconFixed.style.visibility = 'visible';
            mobileIcon.style.visibility = 'visible';
            icon.style.visibility = 'hidden';
          } else {
            iconFixed.style.visibility = 'hidden';
            mobileIcon.style.visibility = 'hidden';
            icon.style.visibility = 'visible';
          }
        },
        { threshold: 0.5 }
      );
      observer.observe(isMobile ? mobileIcon : icon);
    }
  }
};
